export const CatchReturn = () => {
    window.location.href = 'https://altavozradio.mx/#/'; 
}